// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
export type Block = {
  id: number,
  x: number,
  y: number,
  health: number,
  isDestroyed: boolean,
  cost: number,
  isCore: boolean,
  width: number,
  height: number,
};

/**
 * A namespace for generated helper functions.
 */
export namespace Block {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("id", AlgebraicType.createI32Type()),
      new ProductTypeElement("x", AlgebraicType.createF32Type()),
      new ProductTypeElement("y", AlgebraicType.createF32Type()),
      new ProductTypeElement("health", AlgebraicType.createI32Type()),
      new ProductTypeElement("isDestroyed", AlgebraicType.createBoolType()),
      new ProductTypeElement("cost", AlgebraicType.createI32Type()),
      new ProductTypeElement("isCore", AlgebraicType.createBoolType()),
      new ProductTypeElement("width", AlgebraicType.createI32Type()),
      new ProductTypeElement("height", AlgebraicType.createI32Type()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: Block): void {
    Block.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): Block {
    return Block.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


